// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__0dG8C","pricing":"Footer_pricing__2y1cF","address":"Footer_address__j368U","contacts":"Footer_contacts__hoAtg"};